module.exports = __webpack_public_path__ + "static/OpenID-29463aa87242de152ecdc4314cd434bc.png";